    
import React from "react";

function CheckboxMainGroup(props) {
  return (
      <div className="custom-control custom-checkbox" key={props.id}>
          <input type="checkbox" className="custom-control-input" id={props.id} name={props.name}
              ref={el => el && (el.indeterminate = props.indeterminate)}
              value={props.id} checked={props.checked} onChange={props.onChange} />
          <label className="custom-control-label" htmlFor={props.id}>
              {props.value}
              {
                props.children
                && props.children.length > 0
                && <a href="javascript:void(0);" data-toggle="collapse" data-target={ '#' + props.id + 'types' } aria-expanded="false" aria-controls={ props.id + 'types' } className="collapsed">
                      <span className="fas fa-angle-down fa-fw bold"></span>
                  </a>
              }
          </label>
      </div>
  );
}

export default CheckboxMainGroup;